import type { FaireProductEntity } from "../../entity_types/product";

export const p_rve9mtztbk: FaireProductEntity = {
  token: "p_rve9mtztbk",
  type: "product",
  name: "HOSTESS MAHJONG SHUFFLERS",
  brandToken: "b_byhchvmeak",
  brandName: "Pittsford MRKT",
  imageUrl:
    "https://cdn.faire.com/fastly/c659c7486281c3cc79f4fe76fe24120f0f0ef8267819a85e39dfe67b349e61d2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb7eb084a1040a612c1fd2c89c2c4a775263c90650c6f9c7fa5fadfc1af1938f.png",
    "https://cdn.faire.com/fastly/2e24516060bbfa0cee3aff3b6e547ff54e9b7a334f9b2ebb6965816cb7d952ed.png",
    "https://cdn.faire.com/fastly/419ec3b6cd0ec3f49d3251077add4a4ee00bc888427d33a327b7f553b4d6715d.png",
    "https://cdn.faire.com/fastly/98a9fa4478fa787ce390e58f193d1df3c1e5c4b7b7725a7e2b20a095a6ae0dc2.png",
    "https://cdn.faire.com/fastly/0344e59b16dea3c2cb4bbada1d7567551728ab0e3641501f6819db6849071842.png",
    "https://cdn.faire.com/fastly/ed4e0a6cf2cb4610446b5ca565bfc2e01ed62a7b6d9e672fdd7fa0433440d74d.png",
  ],
  priceDollars: 9,
  description:
    'HOSTESS MAHJONG SHUFFLERS\n\nBring major Palm Springs energy to your next game night with our Palm Springs Yellow Mahjong Shufflers. Designed to make shuffling effortless (and way cuter), these matt shufflers feature our signature scalloped edges and vibrant, retro-inspired color palette that instantly elevates your mahjong setup. Crafted from durable, high-quality acrylic, each shuffler is lightweight yet sturdy—perfect for smooth tile mixing while protecting your table. The bold yellow base paired with playful pink lettering and striped accents adds the ultimate pop of color to your mahjong table, whether you\'re hosting girls’ night, a mahjong club, or weekend brunch with mimosas. Details: * Set of 2 mahjong shufflers * Size: 5.5" x 7.25" * Premium Matte finish * Signature scalloped edge design * Lightweight + durable for easy shuffling * Designed for standard mahjong tiles Perfect for gifting your mahjong-loving bestie or upgrading your own game night aesthetic, these shufflers are where function meets fashion.\n',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:49.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
